import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

interface HeaderProps {
  dimensionName: string;
  selectedValue?: string;
}

const HeaderContainer = styled.div`
  margin: 0.25rem 0 0.5rem;
`;

export const Header: FunctionComponent<HeaderProps> = ({ dimensionName, selectedValue = null }) => {
  const nameToRender =
    dimensionName !== undefined && dimensionName !== '' ? (
      dimensionName
    ) : (
      <FormattedMessage id="dimension-name.fallback" defaultMessage="Variante" />
    );
  return (
    <HeaderContainer data-testid="product-selection-header">
      {nameToRender}
      {nameToRender && selectedValue && ': '}
      {selectedValue && (
        <strong data-testid="product-selection-header-value">{selectedValue}</strong>
      )}
    </HeaderContainer>
  );
};

export default Header;
